import { FC } from "react";

import { CreationCelebration } from "./creation-celebration";
import { useFirstItemCelebration } from "./use-first-item-celebration";

interface FirstItemCelebrationProps {
  itemCount: number;
  enabled?: boolean;
}

export const FirstItemCelebration: FC<FirstItemCelebrationProps> = ({ itemCount, enabled }) => {
  const { isCelebrating, stopCelebrating } = useFirstItemCelebration({ itemCount, enabled });

  return <CreationCelebration isActive={isCelebrating} onComplete={stopCelebrating} />;
};
